import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Btn, Empty, Panel } from "./common";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const inp = "mono mt-1 w-full rounded-sm border border-[#E2E8F0] bg-[#F8FAFC] px-2 py-1.5 text-sm";

function EditLevels({ p, onDone }) {
  const [open, setOpen] = useState(false);
  const [stop, setStop] = useState(String(p.stop));
  const [tp, setTp] = useState(String(p.tp1));
  const [busy, setBusy] = useState(false);
  const s = parseFloat(stop), t = parseFloat(tp);
  const stopDown = s < p.stop;
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/positions/${p.id}/levels`, { stop: s !== p.stop ? s : null, take_profit: t !== p.tp1 ? t : null });
      toast.success(`${p.symbol}: levels updated`); setOpen(false); onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Btn variant="ghost" onClick={() => setOpen(true)} data-testid={`levels-edit-${p.id}`}>Edit SL/TP</Btn>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white" data-testid={`levels-dialog-${p.id}`}>
          <DialogHeader><DialogTitle>{p.symbol} · move stop-loss / take-profit</DialogTitle>
            <DialogDescription>Stop-loss can only be moved UP (locks in more protection). Take-profit can move either way but must stay above the current price.</DialogDescription></DialogHeader>
          <label className="text-xs text-slate-600">Stop-loss (now {p.stop})<input data-testid={`levels-stop-${p.id}`} inputMode="decimal" value={stop} onChange={(e) => setStop(e.target.value)} className={inp} /></label>
          {stopDown && <div className="text-[11px] text-red-600" data-testid={`levels-stop-error-${p.id}`}>Stop-loss can only be moved up (min {p.stop})</div>}
          <label className="text-xs text-slate-600">Take-profit (now {p.tp1})<input data-testid={`levels-tp-${p.id}`} inputMode="decimal" value={tp} onChange={(e) => setTp(e.target.value)} className={inp} /></label>
          <p className="text-[10px] text-slate-500">Example: bought at 25.20 with stop 24.40; price rose to 26.50 → move stop to 25.20 (break-even) so this trade can no longer lose.</p>
          <Btn disabled={busy || !(s > 0) || !(t > 0) || stopDown || (s === p.stop && t === p.tp1)} onClick={save} data-testid={`levels-save-${p.id}`}>{busy ? "Saving…" : "Save"}</Btn>
        </DialogContent>
      </Dialog>
    </>
  );
}

export const ManualPositions = ({ positions, onDone }) => (
  <Panel title="Positions managed by DMI" className="mt-3" testid="live-dmi-positions">
    {!positions?.length ? <Empty>No open DMI positions</Empty> : (
      <div className="custom-scrollbar overflow-x-auto"><table className="tbl w-full">
        <thead><tr><th>Stock</th><th>By</th><th>Qty</th><th>Avg entry</th><th>Stop-loss</th><th>Take-profit</th><th /></tr></thead>
        <tbody>{positions.map((p) => (
          <tr key={p.id} data-testid={`dmi-position-${p.id}`}><td className="mono">{p.symbol}</td><td className="text-[11px]">{p.manual ? "You" : "AI"}</td><td className="mono">{p.qty}</td><td className="mono">{p.avg_entry}</td>
            <td className="mono text-red-600" data-testid={`dmi-position-stop-${p.id}`}>{p.stop}</td><td className="mono text-emerald-600" data-testid={`dmi-position-tp-${p.id}`}>{p.tp1}</td>
            <td>{p.manual ? <EditLevels p={p} onDone={onDone} /> : <span className="text-[10px] text-slate-500">AI-managed</span>}</td></tr>))}
        </tbody></table></div>
    )}
  </Panel>
);
